export const INSTANCE_PATH = 'currencies';
